import React from 'react';
import { Collapse, CollapseProps } from 'antd';
interface Props extends CollapseProps {
  children: React.ReactNode;
}

export default function BaseCollapse(props: Props) {
  const { children, className, ...rest } = props;

  return (
    <Collapse
      {...rest}
      className={className}
      expandIconPosition="right"
      expandIcon={({ isActive }) => (
        <div>
          {isActive ? (
            <span className="icon icon-arrow-top" />
          ) : (
            <span className="icon icon-arrow-bot" />
          )}
        </div>
      )}
    >
      {children}
    </Collapse>
  );
}

BaseCollapse.Panel = Collapse.Panel;
